//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mediaSubNav from "~/components/media-sub-nav";
import SocialShareBtns from "~/components/social-share-btns";
import { KinesisContainer, KinesisElement } from "vue-kinesis";
import mostShares from "~/components/content-elements/most-shares";
import latestEvents from "~/components/content-elements/media-item-list";
import medialistingStyle from "~/components/content-elements/media-listing-style";
import mostSharesImages from "~/components/content-elements/most-shares-images.vue";
import mediaItemsWithSearch from "~/components/loading-placeholders/media-items-with-search";
import mediaSideListingPlaceholder from "~/components/loading-placeholders/media-side-listing-pl-new.vue";
export default {
  data() {
    return {
      mostSharesVal: null,
      searchQuery: "",
      perPage: 8,
      loading: false,
      loadingPress: true,
      currentPage: 1,
      items: [],
      itemsCount: null,
      filters: {
        year: null,
        month: null,
        category: null,
        subCategory: null,
      },
    };
  },
  async asyncData({ store }) {
    await store.dispatch("media/getMedia");
    const seo = store.state["media"].mediaPage.dilmah_in_press_cover.seo;
    return { seo };
  },
  head() {
    return {
      title: this.seo.meta_title,
      meta: [
        {
          name: "description",
          hid: "description",
          content: this.seo.meta_description,
        },
        {
          name: "og:description",
          hid: "og:description",
          content: this.seo.meta_description,
        },
        {
          name: "keywords",
          hid: "keywords",
          content: this.seo.keywords,
        },
        {
          property: "og:url",
          content: `https://www.dilmahtea.com${this.$route.path}`,
        },

        {
          property: "og:image",
          hid: "og:image",
          content: this.seo.share_image_url,
        },
        {
          property: "og:title",
          hid: "og:title",
          content: this.seo.meta_title,
        },
        {
          property: "og:image:alt",
          hid: "og:image:alt",
          content: this.seo.share_image_alt,
        },

        {
          name: "shareImageAlt",
          hid: "shareImage",
          content: this.seo.share_image_alt,
        },
        {
          name: "shareImage",
          hid: "shareImage",
          content: this.seo.share_image_url,
        },
        {
          name: "preventindex",
          hid: "preventindex",
          content: this.seo.prevent_indexing,
        },
      ],
    };
  },
  components: {
    mostShares,
    mediaSubNav,
    latestEvents,
    KinesisElement,
    SocialShareBtns,
    mostSharesImages,
    KinesisContainer,
    medialistingStyle,
    mediaItemsWithSearch,
    mediaSideListingPlaceholder,
  },
  mounted() {
    // this.$store.commit("media/CLEAR_INPRESS_RESULTS");
    if (typeof this.$route.query.filteredText != "undefined") {
      this.currentPage = 1;
    } else {
      this.currentPage =
        typeof this.$route.query.page != "undefined"
          ? this.$route.query.page
          : 1;
    }
    this.filters = {
      year:
        typeof this.$route.query.year != "undefined"
          ? this.$route.query.year
          : "",
      month:
        typeof this.$route.query.month != "undefined"
          ? this.$route.query.month
          : "",
      category:
        typeof this.$route.query.category != "undefined" &&
        this.$route.query.category != ""
          ? this.$route.query.category
          : null,
      subCategory:
        typeof this.$route.query.subCategory != "undefined" &&
        this.$route.query.subCategory != ""
          ? this.$route.query.subCategory
          : null,
    };
    this.$store.dispatch("media/getCategories");
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.searchQuery == "") {
        let data = {
          page: this.currentPage,
          size: this.perPage,
          year: this.filters.year,
          month: this.filters.month,
          category: this.filters.category,
          subCategory: this.filters.subCategory,
        };
        this.$store.dispatch("media/getDilmahInPress", data);
        this.$router.push({
          path: "/media/dilmah-in-press",
          query: data,
        });
      }
    },

    changeEv() {
      if (this.filters.year == "") {
        this.filters.month = "";
      }
    },
    changePage() {
      this.currentPage = 1;
      this.loadingPress = true;
    },
    fetchFilteredItems(data) {
      this.$store.dispatch("filterSearch", data);
      this.$router.push({
        path: "/media/dilmah-in-press",
        query: data,
      });
    },
  },
  computed: {
    eventData() {
      if (this.pageData != null) {
        if (this.pageData.recentItems != null) {
          let data = [...this.pageData.recentItems];
          return data.slice(0, 3);
        }
      }
    },
    mostShares() {
      if (this.pageData != null) {
        if (this.pageData.mostShared != null) {
          this.mostSharesVal = [...this.pageData.mostShared].slice(0, 3);
          return this.mostSharesVal;
        }
      }
    },
    pageData() {
      if (this.$store.state.media.dilmahInPress != null) {
        return this.$store.state.media.dilmahInPress;
      }
    },
    filteredItems() {
      if (this.$store.state.getFilterItems != null) {
        return this.$store.state.getFilterItems.data;
      }
    },
    categorieData() {
      return this.$store.state.media.categories;
    },
    pageItemsLength() {
      if (this.searchQuery == "") {
        if (this.pageData != null) {
          return (this.itemsCount = this.pageData.total_items);
        }
      } else {
        if (this.$store.state.getFilterItems != null) {
          return (this.itemsCount =
            this.$store.state.getFilterItems.total_items);
        }
      }
    },
    monthList() {
      if (this.filters.year != "") {
        return Array.from({ length: 12 }, (_, i) => i + 1);
      } else {
        return ["MONTH"];
      }
    },
    isDisabled() {
      if (this.searchQuery != "") {
        return true;
      }
    },
  },

  watch: {
    currentPage: function (newVal, oldVal) {
      if (this.searchQuery == "") {
        this.fetchData();
      } else {
        let data = {
          size: 8,
          filteredText: this.searchQuery,
          linkFolder: "press-articles",
          page: newVal,
        };
        this.fetchFilteredItems(data);
      }
    },
    $route(to) {
      this.size = 8;
      if (
        typeof to.query.page != "undefined" &&
        typeof to.query.year != "undefined" &&
        typeof to.query.month != "undefined" &&
        typeof to.query.subCategory != "undefined" &&
        typeof to.query.category != "undefined"
      ) {
        this.loadingPress = true;
        this.currentPage = to.query.page;
        this.filters.year = to.query.year;
        this.filters.month = to.query.month;
        this.filters.subCategory = to.query.subCategory;
        this.filters.category = to.query.category;
        this.fetchData();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
      if (typeof to.query.filteredText != "undefined") {
        this.loading = true;
        this.currentPage = to.query.page;
        this.searchQuery = to.query.filteredText;
        this.fetchData();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      } else {
        this.searchQuery = "";
        this.loading = false;
      }
    },
    pageData(val) {
      if (typeof val != "undefined") {
        this.loadingPress = false;
      } else {
        this.loadingPress = true;
      }
    },

    searchQuery: function (newVal, oldVal) {
      this.loading = true;
      // this.items = [];
      this.currentPage = 1;
      let data = {
        size: 8,
        filteredText: newVal.toLowerCase(),
        linkFolder: "press-articles",
        page: this.currentPage,
      };
      this.fetchFilteredItems(data);
    },
    filteredItems(val) {
      this.items = val;
      this.loading = false;
    },
    pageItemsLength(val) {
      this.itemsCount = val;
    },
  },
};
